import React, { useState, useEffect, useRef } from 'react'
import { FaEdit } from 'react-icons/fa'
import { Box, Stack, Icon, Button, Text } from '@/components/lib'

export default function EditableContent ({ multiLine, initialValue, onSave, InputElement, inputProps, DisplayElement, displayProps, placeholder }) {
  const [isEditing, setIsEditing] = useState(false)
  const [value, setValue] = useState(initialValue)
  const inputRef = useRef()

  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  return (
    <>
      {isEditing
        ? (
          <>
            <InputElement
              {...inputProps}
              ref={inputRef}
              placeholder={placeholder}
              value={value}
              onChange={(e) => setValue(e.target.value)}
              onKeyPress={(e) => {
                if (!multiLine && e.key === 'Enter') {
                  setIsEditing(false)
                  onSave(value)
                }
              }}
              onBlur={() => {
                if (!multiLine) {
                  setIsEditing(false)
                  onSave(value)
                }
              }}
            />
            {multiLine && (
              <Stack direction='row' display='flex' justifyContent='end' mt={1}>
                <Button
                  colorPalette='primary' size='sm' onClick={() => {
                    setIsEditing(false)
                    onSave(value)
                  }}
                >Save
                </Button>
                <Button
                  size='sm'onClick={() => {
                    setIsEditing(false)
                    setValue(initialValue)
                  }}
                >Cancel
                </Button>
              </Stack>)}
          </>
          )
        : (
          <DisplayElement
            {...displayProps}
            onClick={() => {
              setIsEditing(true)
              setTimeout(() => inputRef.current.focus(), 0)
            }}
          >
            <Box display='flex' alignItems='center'>
              {!value?.length && placeholder &&
                <Text fontStyle='italic' color='fg.muted'>{placeholder}</Text>}
              {value}
              <Icon as={FaEdit} ml={4} color='fg.subtle' />
            </Box>
          </DisplayElement>
          )}
    </>
  )
}
